import React, { useEffect, useState } from "react";
import { Card, Checkbox, CircularProgress } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Button from "../../Subcomponents/Button";
import cssClasses from "./ConfirmPaymentSchedule.module.css";
import EMandateStepper from "./EMandateStepper";
import { useLocation, useNavigate } from "react-router-dom";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";
import { dismissLoader, presentLoader } from "../../Services/loader";
import axios from "axios";
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";
import AllotmentCalenderIcon from "../../Assets/Images/Common/AllotmentCalender.svg";
import { errorTost } from "../../Services/Toast";

import {
  getEmandateRecords,
  insertEmandateDetailsRecord,
  insertSingleEmandateDetailsRecord,
} from "../../Services/Allotment";
import MandateDaySelectionModal from "../../Modals/EMandate/MandateDaySelectionModal";

const ConfirmPaymentSchedule = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isMobile = window.innerWidth < 768;
  const navigate = useNavigate();

  console.log("ConfirmPaymentSchedule → location.state:", location.state); // Log the whole state

  const allotment = location.state.allotment;
  const allotmentPaymentId = location.state?.allotmentPaymentId; // Get the allotmentPaymentId from location state
  const bankName = location.state?.bankName + location.state?.branchName; // Get the allotmentData from location state
  console.log("totalMandateAmount in Confirm Payment schedule", bankName);
  const bookingId = location.state?.bookingId;
  console.log("bookingId in Confirm Payemnt schedule", bookingId);
  // ✅ Get split data and current index (from Split Amount flow)

  const currentIndex = location.state?.currentIndex ?? 0;
  const currentApplicant =
    location.state?.activeApplicant ||
    location.state?.activeApplicant[currentIndex];

  // ✅ Get single applicant data (from Single Applicant flow)
  const selectedApplicantData = location.state?.selectedApplicantData;

  // ✅ Combine both into a single value (if any)
  const activeApplicant = selectedApplicantData || currentApplicant;
  console.log("activeApplicant===================", activeApplicant[0]);
  const bankDetails = location.state?.bankDetails;
  console.log("bankDetails in Confirm Payment schedule", bankDetails);

  const [startDate, setStartDate] = useState(null); // State to store start date
  const [endDate, setEndDate] = useState(null); // State to store end date
  const [checked, setChecked] = useState(false);
  const [activeStep] = useState(3);
  const [insertedData, setInsertedData] = useState(null);
  const [paymentAmountDetails, setPaymentAmountDetails] = useState({
    totalMandateAmount: 0,
    totalScheduleBasic: 0,
    totalScheduleTax: 0,
    totalPayments: 0,
    moreThanOneLakhCount: 0,
    lessThanOneLakhCount: 0,
  });
  const [paymentSchedule, setPaymentSchedule] = useState([]); // State to store the fetched schedule data
  const [noPaymentSchedule, setNoPaymentSchedule] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(
    "Click button to register eNACH mandate.",
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openMandateDayModal, setOpenMandateDayModal] = useState(false);

  useEffect(() => {
    dispatch(actions.activeMenu("emandateallotments"));
  }, [dispatch]);

  const HARDCODED_MANDATE_DATA = {
    tarCall: false,
    features: {
      showPGResponseMsg: true,
      enableAbortResponse: true,
      enableNewWindowFlow: true, //for hybrid applications please disable this by passing false
      enableExpressPay: true,
      siDetailsAtMerchantEnd: true,
      enableSI: true,
    },
    consumerData: {
      // merchantId: "L1113512", //live merchant id
      merchantId: `${process.env.REACT_APP_EMANDATE_LIVE_MERCHANT_ID}`, //live merchant id
      // 'deviceId': 'WEBSH2',    //possible values 'WEBSH1' and 'WEBSH2'

      // returnUrl: `https://virtualaccuat.vjerp.com/api/paynimo-response`,
      returnUrl: `${process.env.REACT_APP_EMANDATE_RETURN_URL}paynimo-response`,
      // returnUrl: `http://localhost:${backendPort}/api/paynimo-response`, //merchant response page URL
      responseHandler: "handleResponse",
      paymentMode: "all",
      // 'merchantLogoUrl': 'https://www.paynimo.com/CompanyDocs/company-logo-md.png',  //provided merchant logo will be displayed
      // merchantLogoUrl:"https://vilajavdekar.com/images/vilas-javdekar-logo.png", //provided merchant logo will be displayed
      merchantLogoUrl: `${process.env.REACT_APP_EMANDATE_MERCHANT_LOGO_URL}vilas-javdekar-logo.png`, //provided merchant logo will be displayed
      currency: "INR",
      consumerId: `${bookingId + activeApplicant[0]?.pan}`, //Your unique consumer identifier to register a eMandate/eNACH
      consumerMobileNo: activeApplicant[0]?.contactNumber?.slice(-10),
      consumerEmailId: activeApplicant[0]?.email || "test@test.com",
      txnId: `TXN${Date.now()}`, //Unique merchant transaction ID
      items: [
        {
          itemId: "FIRST",
          amount: "1",
          comAmt: "0",
        },
      ],
      customStyle: {
        PRIMARY_COLOR_CODE: "#3977b7", //merchant primary color code
        SECONDARY_COLOR_CODE: "#FFFFFF", //provide merchant's suitable color code
        BUTTON_COLOR_CODE_1: "#1969bb", //merchant's button background color code
        BUTTON_COLOR_CODE_2: "#FFFFFF", //provide merchant's suitable color code for button text
      },
      accountNo: bankDetails?.accountNumber || "", //Pass this if accountNo is captured at merchant side for eMandate/eNACH
      // 'accountNo': '',    //Pass this if accountNo is captured at merchant side for eMandate/eNACH
      accountHolderName:
        activeApplicant[0]?.nameAsPerPan || activeApplicant[0]?.name, //Pass this if accountHolderName is captured at merchant side for ICICI eMandate & eNACH registration this is mandatory field, if not passed from merchant Customer need to enter in Checkout UI.
      // 'accountHolderName': '',  //Pass this if accountHolderName is captured at merchant side for ICICI eMandate & eNACH registration this is mandatory field, if not passed from merchant Customer need to enter in Checkout UI.
      ifscCode: bankDetails?.ifscCode, //Pass this if ifscCode is captured at merchant side.
      accountType: "Saving", //Required for eNACH registration this is mandatory field
      debitStartDate: startDate,
      debitEndDate: endDate,
      maxAmount: process.env.REACT_APP_ENVIRONMENT == "production"
        ? paymentAmountDetails?.totalMandateAmount
        : "1",
      amountType: "M",
      frequency: "MNTH", //  Available options DAIL, WEEK, MNTH, QURT, MIAN, YEAR, BIMN and ADHO
    },
  };

  console.log("HARDCODED_MANDATE_DATA", HARDCODED_MANDATE_DATA);

  useEffect(() => {
    const listener = (event) => {
      const res = event.detail;
      setLoading(false);

      if (res?.paymentMethod?.paymentTransaction) {
        const status = res.paymentMethod.paymentTransaction.statusCode;
        if (status === "0300") {
          setMessage(
            `✅ Success! Mandate ID: ${res.paymentMethod.paymentTransaction.transactionId}`,
          );
        } else if (status === "0398") {
          setMessage("⏳ Initiated/Pending. Please check status later.");
        } else {
          setMessage(`❌ Failed/Error. Code: ${status}`);
        }
      } else {
        setMessage("❌ Transaction Failed or User Closed Window.");
      }
    };

    window.addEventListener("paynimo-response", listener);
    return () => window.removeEventListener("paynimo-response", listener);
  }, []);

  const initiateMandate = async (emandateRegistrationPayload) => {
    setLoading(true);
    console.log(
      "emandateRegistrationPayload inside initiate mandate --->",
      emandateRegistrationPayload,
    );

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_EMANDATE_API_URL}generate-mandate-config`,
        {
          ...HARDCODED_MANDATE_DATA,
          meta: emandateRegistrationPayload,
        },
      );
      const configJson = response.data;
      configJson.consumerData.responseHandler = "handlePaynimoResponse";

      if (window.$?.pnCheckout) {
        window.$.pnCheckout(configJson);
        if (
          configJson.features.enableNewWindowFlow &&
          window.pnCheckoutShared
        ) {
          window.pnCheckoutShared.openNewWindow();
        }
      } else {
        setMessage("Paynimo Checkout JS not loaded.");
        setLoading(false);
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleOpenEMandate = async (emiDay) => {
    console.log("inside handle open mandate ....");

    if (isSubmitting) return; // extra safety guard
    try {
      console.log("activeApplicant--->", activeApplicant);
      setIsSubmitting(true);
      if (activeApplicant && activeApplicant.length > 0) {
        let totalPercentage = 0;

        // Sum the percentages
        activeApplicant.forEach((applicant) => {
          totalPercentage += applicant.percentage || 0;
        });

        console.log("Total Percentage:", totalPercentage);

        // Decide the value of isSplit based on the total percentage
        const isSplit =
          totalPercentage === activeApplicant[0].percentage ? false : true;
        console.log("isSplit:", isSplit);

        if (totalPercentage === 100) {
          // Step 2: Calculate the total mandate amount (assuming you have totalMandateAmount in your state)
          const totalMandateAmount = location.state?.totalMandateAmount || 0;

          // Step 3: Calculate the individual mandate amounts based on each applicant's percentage
          const updatedApplicants = activeApplicant.map((applicant) => {
            const singleMandateAmount = Math.round(
              (totalMandateAmount * applicant.percentage) / 100,
            );
            applicant.amount = singleMandateAmount; // Update the amount for each applicant
            return applicant;
          });

          // Step 4: Filter out applicants with 0% split ratio if needed
          const filteredApplicants = updatedApplicants.filter(
            (applicant) => applicant.percentage > 0,
          );

          // Step 5: Insert eMandate details for the selected applicants in one request
          const insertPayload = filteredApplicants.map((applicant) => ({
            allotmentPaymentId: allotmentPaymentId,
            crmId: allotment?.CRM[0]?.id || null,
            name: applicant.name,
            pan: applicant.pan,
            splitRatio: applicant.percentage,
            emandateAmount: applicant.amount,
            emandateStatus: "Pending", // Set initial status to "Pending"
            consumerId: `${bookingId || ""}${applicant?.pan || ""}`,
            isSplit: isSplit, // This value determines whether it's split or not
            emiDebitDay : emiDay
          }));

          // console.log("Insert eMandate Details Payload:", insertPayload);

          const result = await insertEmandateDetailsRecord(insertPayload); // Function that inserts data into DB
          console.log("result----->", result);

          if (result.some((r) => r.isInserted === false)) {
            // Show toast with the message from result
            // errorTost(result.message); // Show warning if insertion is skipped
            console.log(
              "Error in insertion:",
              result.find((r) => r.isInserted === false)?.message,
            );
          } else {
            console.log("eMandate details inserted/updated successfully.");
            let emandateRegistrationPayload;
            // Iterate over the result array for each applicant (if it's an array of results)
            const finalPayload = result
              .map((res) => {
                if (!res.isInserted) {
                  console.log("Mandate failed for this record.");
                  return null; // Skip this record if it wasn't inserted
                }

                // Assuming `res` contains either `insertedData` or `updatedData`
                const insertResultData = {
                  ...(res.insertedData || res.updatedData?.[0]),
                };

                console.log("Combined Data for applicant:", insertResultData);

                // Set the inserted data
                setInsertedData(insertResultData);

                return insertResultData; // Return the data for this applicant
              })
              .filter(Boolean); // Filter out null values in case any record was skipped

            console.log("finalPayload", finalPayload);

            emandateRegistrationPayload = {
              isSplit:
                finalPayload[0]?.splitRatio === 100 ||
                result[0]?.splitRatio === 100
                  ? false
                  : true,
              bookingId: bookingId,
              allotmentPaymentId: allotmentPaymentId,
              bankName: bankName,
              splitPercentage:
                finalPayload[0]?.splitRatio || result[0]?.splitRatio,
              splitAmount:
                finalPayload[0]?.emandateAmount || result[0]?.emandateAmount,
              totalAmount: paymentAmountDetails?.totalMandateAmount,
              emiDebitDay: emiDay,
              environment: process.env.REACT_APP_ENVIRONMENT
            };
            console.log(
              "emandateRegistrationPayload--->",
              emandateRegistrationPayload,
            );

            await initiateMandate(emandateRegistrationPayload);
          }
        } else {
          console.log(
            "The total percentage of both applicants must equal 100.",
          );

          const emandateRecord = await getEmandateRecords([
            activeApplicant[0]?.allotmentPaymentId,
          ]);
          console.log("emandate record ", emandateRecord);
          console.log("activeApplicant--->", activeApplicant);

          const totalSplitRatio = emandateRecord.reduce((sum, applicant) => {
            return sum + Number(applicant.splitRatio || 0);
          }, 0);

          console.log("Total Split Ratio:", totalSplitRatio);

          if (totalSplitRatio < 100) {
            console.log("total split ratio is not 100");
            errorTost("Total Split Ratio is less than 100%");
            return;
          }
          const emandateRegistrationPayload = {
            isSplit: activeApplicant[0]?.splitRatio === 100 ? false : true,
            bookingId: bookingId,
            allotmentPaymentId: allotmentPaymentId,
            bankName: bankName,
            splitPercentage: activeApplicant[0]?.splitRatio,
            splitAmount: activeApplicant[0]?.emandateAmount,
            totalAmount: paymentAmountDetails?.totalMandateAmount,
            emiDebitDay: emiDay,
            environment: process.env.REACT_APP_ENVIRONMENT
          };
          console.log(
            "emandateRegistrationPayload in else --->",
            emandateRegistrationPayload,
          );

          await initiateMandate(emandateRegistrationPayload);
        }
      } else {
        console.log("Missing 'percentage' property for one or both applicants");
      }
    } catch (err) {
      console.error("Error in eMandate flow:", err);
      setIsSubmitting(false); // allow retry only if failed
    }
  };

  // fetch mandate payment amounts llike total amount , schedule basic, tax amount etc
  useEffect(() => {
    const fetchPaymentPlan = async (bookingId) => {
      try {
        presentLoader();
        const response = await axios.post(
          `${process.env.REACT_APP_PAYMENT_LINK_URL}emandate/getPaymentPlanByBookingId`,
          { bookingId },
        );
        console.log("getPaymentPlanByBookingId====>", response);

        const {
          totalMandateAmount,
          totalScheduleBasic,
          totalScheduleTax,
          totalPayments,
          amountSummary,
          paymentPlanScheduleData,
        } = response.data;

        const totalAmount = totalMandateAmount; // Total Amount
        // const splitRatio = activeApplicant?.splitRatio; // Split ratio for active applicants
        const splitRatio =
          activeApplicant[0]?.percentage || activeApplicant[0].splitRatio; // Split ratio for active applicants

        // Calculate % of the total amount
        const splitAmount = totalAmount * (splitRatio / 100);
        console.log("Split Amount:", splitAmount);

        // Update state with the fetched payment plan details
        setPaymentAmountDetails({
          totalMandateAmount,
          totalScheduleBasic,
          totalScheduleTax,
          totalPayments,
          moreThanOneLakhCount: amountSummary.moreThanOneLakhCount.count,
          lessThanOneLakhCount: amountSummary.lessThanOrEqualOneLakhCount.count,
          splitAmount: splitAmount,
        });

        console.log("paymentPlanScheduleData", paymentPlanScheduleData);

        // If there's no payment schedule data, set noPaymentSchedule to true
        if (paymentPlanScheduleData.length === 0) {
          setNoPaymentSchedule(true);
          setPaymentSchedule([]); // Clear the payment schedule state if empty
        } else {
          // Calculate 30% for each payment schedule
          const updatedPaymentSchedules = calculateSplitAmount(
            paymentPlanScheduleData,
            // activeApplicant?.splitRatio,
            activeApplicant[0]?.percentage || activeApplicant[0]?.splitRatio,
          );

          console.log("updatedPaymentSchedules---->", updatedPaymentSchedules);

          const installmentDates = updatedPaymentSchedules?.sort(
            (a, b) => new Date(a.installmentDate) - new Date(b.installmentDate),
          );

          // Extract the first and last installment dates
          const newStartDate = installmentDates[0]?.installmentDate; // First installment date
          const newEndDate =
            installmentDates[installmentDates.length - 1]?.installmentDate; // Last installment date

          console.log("Start Date:", newStartDate);
          console.log("End Date:", newEndDate);

          // Format the dates before setting them in state
          const formattedStartDate = formatDateDDMMYYYY(newStartDate);
          const formattedEndDate = formatDateDDMMYYYY(newEndDate);

          // Set the formatted start and end dates to state
          setStartDate(formattedStartDate);
          setEndDate(formattedEndDate);

          setPaymentSchedule(updatedPaymentSchedules);
          setNoPaymentSchedule(false); // Set to false if payment schedule is present
        }
      } catch (error) {
        console.error("Error fetching payment plan:", error);
        dismissLoader();
      } finally {
        dismissLoader();
      }
    };

    if (bookingId) {
      fetchPaymentPlan(bookingId); // Fetch the payment plan for this bookingId
    }
  }, [bookingId]);

  const calculateSplitAmount = (schedules, splitRatio) => {
    console.log("schedules --->", schedules);

    return schedules.map((schedule) => {
      // Calculate 30% of the scheduleAmountWithTax
      const splitAmount = schedule.scheduleAmountWithTax * (splitRatio / 100);
      let roundedAmount = Math.round(splitAmount * 100) / 100;
      console.log(roundedAmount); // 105258.60
      // Return a new object with the splitAmount added
      return {
        ...schedule,
        splitAmount: roundedAmount,
        mandateSplitRatio: splitRatio,
        paymentType: roundedAmount > 100000 ? "Bullet" : "Monthly",
      };
    });
  };
  const formatDateDDMMYYYY = (isoDate) => {
    if (!isoDate) return "";

    const date = new Date(isoDate);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  console.log("paymentSchedule====>", paymentSchedule);

  return (
    <div style={{ overflowY: "auto" }}>
      <div className={cssClasses.pageWrapper}>
        <EMandateStepper activeStep={activeStep} />
        <div className={cssClasses.wrapper}>
          {currentApplicant.length > 0 && (
            <Card className={cssClasses.mandateProgressCard} elevation={0}>
              <div className={cssClasses.mandateHeader}>
                <strong>E-Mandate Progress</strong>
                {/* <span>(0/{currentApplicant.length} completed)</span> */}
                <span>
                  ({currentIndex}/{currentApplicant.length} completed)
                </span>
              </div>

              <div className={cssClasses.mandateFlow}>
                {currentApplicant.map((applicant, index) => (
                  <React.Fragment key={applicant.id}>
                    <div className={cssClasses.mandateUser}>
                      <div className={cssClasses.radioCircle} />
                      <div>
                        <div className={cssClasses.userName}>
                          {applicant.name} {/* Display full name */}
                        </div>
                        <div className={cssClasses.userMeta}>
                          {applicant.percentage || applicant?.splitRatio}% • ₹
                          {numberWithCommas(applicant.splitAmount)}
                        </div>
                      </div>
                    </div>

                    {index !== currentApplicant.length - 1 && (
                      <div className={cssClasses.arrow}>→</div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </Card>
          )}

          {/* Header */}
          <div className={cssClasses.header}>
            <h2>Payment Schedule</h2>
            <p>
              {/* Payment schedule for{" "} */}
              <p>
                Payment schedule for{" "}
                {activeApplicant[0]?.nameAsPerPan ||
                  activeApplicant[0]?.name ||
                  "Applicant"}{" "}
                - (
                {activeApplicant[0]?.splitRatio ||
                  activeApplicant[0]?.percentage}
                %)
              </p>
            </p>{" "}
            {/* Display first applicant's name */}
          </div>

          {/* Summary Cards */}
          <div className={cssClasses.summaryRow}>
            <Card className={cssClasses.summaryCard}>
              <span>Total Payments</span>
              <strong>{paymentAmountDetails?.totalPayments}</strong>
            </Card>

            <Card className={cssClasses.summaryCard}>
              <span>Monthly</span>
              <strong>{paymentAmountDetails?.lessThanOneLakhCount}</strong>
            </Card>

            <Card className={cssClasses.summaryCard}>
              <span>Bullet</span>
              <strong>{paymentAmountDetails?.moreThanOneLakhCount}</strong>
            </Card>
          </div>

          {/* Info Box */}
          <div className={cssClasses.infoBox}>
            <InfoOutlinedIcon sx={{ fontSize: 20 }} />
            <div>
              <strong>
                Total Amount: ₹
                {numberWithCommas(paymentAmountDetails?.splitAmount)}
                {/* ({" "}{paymentAmountDetails?.mandateSplitRatio} % ) */}
              </strong>

              <p>
                Amount will be auto-debited from your registered bank account on
                the scheduled dates.
              </p>
            </div>
          </div>

          <div className={cssClasses.scrollableContainer}>
            <Card className={cssClasses.scheduleCard}>
              <div className={cssClasses.tableHeader}>
                Payment Schedule{" "}
                <strong>({paymentSchedule.length} installments)</strong>
              </div>

              <div className={cssClasses.scrollableContent}>
                <div className={cssClasses.table}>
                  <div className={cssClasses.tableHeader}>
                    <div className={cssClasses.rowLeft}>
                      <span className={cssClasses.index}>#</span>{" "}
                      {/* Column header for Index */}
                      <span className={cssClasses.index}>
                        Demand Date
                      </span>{" "}
                      {/* Column header for Installment Date */}
                    </div>
                    <div className={cssClasses.rowRight}>
                      <span className={cssClasses.headingBadge}>
                        Payment Type
                      </span>{" "}
                      {/* Column header for Payment Type */}
                      <span className={cssClasses.headingBadge}>
                        Split Amount
                      </span>{" "}
                      {/* Column header for Split Amount */}
                    </div>
                  </div>

                  {noPaymentSchedule ? (
                    <div
                      className={cssClasses.noDataMsg}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexDirection: "column",
                      }}
                    >
                      <div className={cssClasses.emptyIcon}>
                        <img
                          src={AllotmentCalenderIcon}
                          alt="No Payment Schedule"
                          style={{ width: 50, height: 50 }}
                        />
                      </div>
                      <div className={cssClasses.emptyTitle}>
                        No Payment Schedule available for this booking.
                      </div>
                    </div>
                  ) : (
                    paymentSchedule.map((item, index) => (
                      <div
                        key={item.scheduledId}
                        className={cssClasses.tableRow}
                      >
                        <div className={cssClasses.rowLeft}>
                          <span className={cssClasses.index}>{index + 1}</span>{" "}
                          {/* Index column */}
                          <span>
                            {formatDateDDMMYYYY(item.installmentDate)}
                          </span>{" "}
                          {/* Installment Date column */}
                        </div>

                        <div className={cssClasses.rowRight}>
                          <span className={cssClasses.badge}>
                            {item.paymentType}
                          </span>
                          <strong>{numberWithCommas(item.splitAmount)}</strong>{" "}
                          {/* Split Amount column */}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </Card>
          </div>
          {/* Checkbox */}

          <div className={cssClasses.consentBox}>
            <Checkbox
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
              sx={{
                padding: "0px !important",
                marginRight: "8px",
                marginTop: isMobile ? "1px" : "0",
                fontSize: "medium !important", // For the font size of the checkbox label
                display: "flow",
                "& .css-i4bv87-MuiSvgIcon-root": {
                  fontSize: "medium", // Adjust the font size of the checkbox icon
                },
              }}
              disabled={noPaymentSchedule} // Disable the checkbox if no payment schedule
            />
            <p>
              I have read and understood the complete payment schedule. I
              authorize the bank to auto-debit the mentioned amounts from my
              registered bank account on the scheduled dates.
            </p>
          </div>

          {/* Footer Buttons */}

          <div className={cssClasses.footerRow}>
            <Button
              btnName="Back"
              style={backBtnStyle}
              clicked={() => navigate("/Home/EMandate")}
            />

            {/* <Button
              btnName={
                isSubmitting ? (
                  <CircularProgress size={18} sx={{ color: "#fff" }} />
                ) : (
                  "Confirm & Initiate E-Mandate"
                )
              }
              style={{
                ...confirmBtnStyle,
                backgroundColor:
                  checked && !isSubmitting ? "rgb(22, 52, 117)" : "#94a3b8",
              }}
              disable={!checked || isSubmitting || noPaymentSchedule} // Disable the button if no payment schedule
              clicked={handleOpenEMandate}
            /> */}

            <Button
              btnName={
                isSubmitting ? (
                  <CircularProgress size={18} sx={{ color: "#fff" }} />
                ) : (
                  "Confirm & Initiate E-Mandate"
                )
              }
              style={{
                ...confirmBtnStyle,
                backgroundColor:
                  checked && !isSubmitting ? "rgb(22, 52, 117)" : "#94a3b8",
              }}
              disable={!checked || isSubmitting || noPaymentSchedule}
              clicked={() => setOpenMandateDayModal(true)}
            />
          </div>
        </div>
      </div>

      <MandateDaySelectionModal
        open={openMandateDayModal}
        onClose={() => setOpenMandateDayModal(false)}
        onConfirm={(day) => {
          console.log("Selected Mandate Day:", day);
          setOpenMandateDayModal(false);
          handleOpenEMandate(day); // continue original flow
        }}
      />
    </div>
  );
};

export default ConfirmPaymentSchedule;

/* ---------- button styles ---------- */

const backBtnStyle = {
  height: "48px",
  borderRadius: "12px",
  border: "1px solid #d1d5db",
  backgroundColor: "#ffffff",
  color: "#0f172a",
  boxShadow: "none",
  fontSize: "1.52rem",
};

const confirmBtnStyle = {
  height: "48px",
  borderRadius: "12px",
  border: "none",
  color: "#ffffff",
  fontSize: "1.52rem",
};